import { useMemo } from 'react';

import type { Place } from '../types/warehouse.types';

export const usePlaceData = (places: Map<string, Place>) => {
  const allPlaces = useMemo(() => Array.from(places.values()), [places]);

  const allCustomers = useMemo(() => {
    const customers = new Set<string>();
    allPlaces.forEach(place => {
      if (place.customer_name) {
        customers.add(place.customer_name);
      }
    });
    return Array.from(customers).sort();
  }, [allPlaces]);


  const allPalletCustomers = useMemo(() => {
    const customers = new Set<string>();
    allPlaces.forEach(place => {
      if (place.pallet_customer_name) {
        customers.add(place.pallet_customer_name);
      }
    });
    return Array.from(customers).sort();
  }, [allPlaces]);

  return { allPlaces, allCustomers, allPalletCustomers }
};
